import styled from 'styled-components';

export const SectionContainer = styled.section`
  min-height: 600px;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
  position: relative;
  overflow: hidden;
  padding: 4rem 2rem 0 2rem; 
  
  @media (max-width: 768px) {
    flex-direction: column;
    min-height: auto;
    padding: 3rem 1rem 0 1rem; 
    overflow: visible;
  }
  
  @media (max-width: 480px) {
    padding: 2rem 1rem 0 1rem; 
  }
`;

export const LeftContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10rem;
  
  @media (max-width: 1024px) {
    padding-left: 6rem;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
    align-items: center;
    margin-bottom: 0; 
  }
`;

export const RightContainer = styled.div`
  width: 50%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  
  @media (max-width: 768px) {
    width: 100%;
    height: auto; 
    min-height: 300px; 
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }
  
  @media (max-width: 480px) {
    min-height: 250px; 
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 2.5rem;
  margin-top: 0;
  color: #333;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  }
`;

export const StepCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #222;
  border-radius: 50px;
  padding: 0.6rem 1.5rem;
  margin-bottom: 0.5rem;
  margin-left: 2rem;
  width: 100%;
  max-width: 320px;
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;
  
  @media (max-width: 768px) {
    max-width: 100%;
    margin: 0 auto 0.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem 1.2rem;
  }
`;

export const StepContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StepIcon = styled.div`
  margin-left: 0.8rem;
  
  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
  
  @media (max-width: 480px) {
    margin-left: 0.6rem;
    
    img {
      width: 18px;
      height: 18px;
    }
  }
`;

export const StepTitle = styled.h3`
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const StepDescription = styled.p`
  font-size: 0.85rem;
  font-weight: 300;
  line-height: 1.4;
  color: #333;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  max-width: 380px;
  width: 100%;
  
  @media (max-width: 768px) {
    text-align: center;
    max-width: 100%;
    margin: 0.5rem auto 1.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.8rem;
    line-height: 1.5;
    margin-bottom: 1.2rem;
  }
`;

export const PersonImage = styled.img`
  height: 100%;
  max-height: 745px;
  object-fit: cover;
  object-position: center;
  display: block;
  
  @media (max-width: 768px) {
    height: auto;
    max-height: none; 
    width: 100%;
    object-fit: contain; 
    border-radius: 8px;
  }
  
  @media (max-width: 480px) {
    height: auto;
    max-height: none; 
    width: 100%;
    object-fit: contain; 
    border-radius: 8px;
  }
`;